import classNames from 'classnames'
import { MapPinIcon } from '@heroicons/react/24/outline'

import { Link } from '@elements/link'
import { useGoogleMapsLink } from '@hooks/google-maps-link'
import { Address } from 'types/common'

export function PlaceDisplay({
  className,
  place,
  address,
}: {
  className?: string
  place: string
  address: Address
}) {
  const googleMapsLink = useGoogleMapsLink(address)

  if (!googleMapsLink) return null
  return (
    <Link
      href={googleMapsLink}
      className='flex items-center justify-start'
      rel='noreferrer'
      target='_blank'
    >
      <MapPinIcon className='w-4 h-4 stroke-2' />
      <span className={classNames('pl-0.5 text-sm', className)}>{place}</span>
    </Link>
  )
}
